import React, { useEffect } from "react"
import { Outlet, useLocation } from "react-router-dom"
import Header from "./header"
import Footer from "./footer"
import { features } from "../config/features"

const allMenuLinks = [
  // {
  //   name: "Talk Archive",
  //   link: "/talk-archive",
  // },
  {
    name: "Schedule",
    link: "/schedule",
  },
  {
    name: "Speakers",
    link: "/speakers",
  },
  {
    name: "Venue",
    link: "/venue",
  },
  {
    name: "Conference Map",
    link: "/conference-map",
  },
  {
    name: "Become a Sponsor",
    link: "/become-a-sponsor",
  },
  {
    name: "Convince Your Boss",
    link: "/convince-your-boss",
  },
  {
    name: "Team",
    link: "/team",
  },
]

const hiddenLinks = features.scheduleAndSpeakers
  ? []
  : ["/schedule", "/speakers"]

const menuLinks = allMenuLinks.filter(({ link }) => !hiddenLinks.includes(link))

const Layout = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <div className="flex min-h-screen flex-col bg-cnd-bone font-sans text-cnd-slate antialiased">
      <Header menuLinks={menuLinks} />
      <main className="relative isolate grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

export default Layout
